module.exports = __webpack_public_path__ + "static/media/26.5595f01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/26.jpg
// module id = 559
// module chunks = 0